<div class="container-products">
  <div class="product-list">
    <div *ngFor="let product of sortedProducts ">
      <div *ngIf="!product.mockup">
        <a [class]="productAccess(product.name) ? 'product':'product-disabled'"
           [href]="product.url">
          <img [src]="product.productIcon" />
          <div class="product-name">{{ product.name }}</div>
        </a>
      </div>
      <div *ngIf="product.mockup">
        <a [class]="productAccess(product.name) ? 'product':'product-disabled'"
           [routerLink]="product.routerLink"
           target="_self">
          <img [src]="product.productIcon" />
          <div class="product-name">{{ product.name }}</div>
        </a>
      </div>
    </div>
  </div>
</div>